import { render, staticRenderFns } from "./Desarrollos.vue?vue&type=template&id=1b099682&"
import script from "./Desarrollos.vue?vue&type=script&lang=js&"
export * from "./Desarrollos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports